<template>
  <div>
    <svg width="100%" :height="height+50" ref="svg"
    @mousedown="mousedown" @touchstart="mousedown" 
    @touchend="mouseup" @mouseup="mouseup" 
    @mousemove="mousemove" @touchmove="mousemove">

      <defs>
        <linearGradient id="e" :x1="x(90)" y1="210" :x2="x(95)" y2="210" gradientUnits="userSpaceOnUse" gradientTransform="rotate(0)">
          <stop stop-color="#577bb7" offset="0" />
          <stop stop-color="rgba(0,0,0,0)" offset="1" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="f" :x1="x(3)" y1="210" :x2="x(10)" y2="210" gradientUnits="userSpaceOnUse" gradientTransform="rotate(0)">
          <stop stop-color="rgba(0,0,0,0)" offset="0" />
          <stop stop-color="#577bb7" offset="1" />
        </linearGradient>
      </defs>
      <!-- <line :x1="padding.left" :y1="height" :x2="width" :y2="height" stroke="#111" /> -->
      <line :x1="padding.left" :y1="y(0)" :x2="padding.left" y2="0" stroke="#111" />
      <g v-for="(line, index) in ygrid">
        <line v-if="line == 0"
          :x1="padding.left" :y1="y(line)"
          :x2="width" :y2="y(line)"
          stroke="#111" />
        <!-- <line v-else
          :x1="padding.left" :y1="y(line)"
          :x2="width" :y2="y(line)"
          stroke="#ddd" /> -->
        <text 
          :x="padding.left-6" 
          :y="y(line)+3" 
          text-anchor="end"
          class="grid-label">
          {{format(line)}}
        </text>
      </g>
      <g v-for="(line, index) in xgrid">
        <!-- <line v-if="line == 50"
          :x1="x(50)" :y1="0"
          :x2="x(50)" :y2="height"
          stroke="#111" /> -->
        <text 
          :x="x(line)" 
          :y="height" 
          text-anchor="middle"
          class="grid-label">
          {{line}}
        </text>
      </g>
      <polyline :points="pointsLeft" stroke="url(#f)" stroke-width="3" />
      <polyline 
        :points="points"
        style="fill:none;stroke:#577bb7;stroke-width:3" />
      <polyline :points="pointsRight" stroke="url(#e)" stroke-width="3" />
      <circle v-for="(dot, index) in data.slice(1)"
        :cx="x(dot[0])" :cy="y(dot[1])" r="6"  fill="#577bb7" 
        @mouseover="mouseover(dot)" @mouseleave="mouseleave()"/>

      <text 
        :x="padding.left+10" 
        :y="yCapped(wealth)-10" 
        fill="#D13D3D" 
        class="vermoegen-label">
        Ihr Vermögen: {{format(wealth)}}€
      </text>
      <line 
        :x1="padding.left" 
        :y1="yCapped(wealth)" 
        :x2="width" 
        :y2="yCapped(wealth)" 
        stroke="#D13D3D"
        stroke-width="3" />
      <circle :cx="x(95)" :cy="yCapped(wealth)" r="10"  stroke="#D13D3D" fill="#fff" stroke-width="2" class="wealthButton"/>
      <rect :x="x(95)-4" :y="yCapped(wealth)-4" width="8" height="8" fill="#D13D3D" :transform="rotate(45,x(95),yCapped(wealth))"/>
      <line :x1="x(95)-7" :y1="yCapped(wealth)" :x2="x(95)+7" :y2="yCapped(wealth)" stroke="#fff" stroke-width="3" />
      <!-- <polygon :points="triangleUp" fill="#D13D3D" /> -->

      <!-- Achsenbeschriftungen -->
      <text 
          x="10" 
          :y="height/2" 
          text-anchor="start"
          class="grid-label"
          transform="rotate(-90,10, 200)">
        Nettovermögen
      </text>
      <text 
          :x="x(50)" 
          :y="height+25" 
          text-anchor="middle"
          class="grid-label">
        Prozent der Bevölkerung
      </text>
      <text 
          :x="x(50)" 
          :y="height+40" 
          text-anchor="middle"
          class="grid-label">
        (nach Vermögen gereiht)
      </text>
    </svg>
  </div>
</template>

<script>
import {scaleLinear} from 'd3'
import {format} from 'd3'
import debounce from 'debounce'

export default {
  name: 'lineChart',
  props: {
    data: Array,
    wealth: Number,
    domain: Array,
  },
  data () {
    return {
      padding: { left: 80 },
      ygrid: [0,100000,200000,300000,400000,500000,600000,700000,800000],
      xgrid: [10,20,30,40,50,60,70,80,90],
      width: 600,
      height: 400,
      verticalScale: 2000,
      dragging: false
    }
  },
  methods: {
    format (number) {
      if (number == 0) { return '0'}
      return format(",.3r")(number).replace(',','.')
    },
    y (val) {
      let x = scaleLinear()
        .domain(this.domain)
        .range([this.height, 0])
      return x(val)
    },
    yCapped (val) {
      let x = scaleLinear()
        .domain(this.domain)
        .range([this.height, 0])
      return x(val) > 22 ? x(val) : 22
    },
    x (val) {
      let x = scaleLinear()
        .domain([0, 100])
        .range([this.padding.left, this.width])
      return x(val)
    },
    yToWealth (val) {
      let x = scaleLinear()
        .domain([this.height, 0])
        .range(this.domain)
      return x(val)
    },
    fitProjection () {
      this.width = this.$refs.svg.getBoundingClientRect().width
    },
    mouseover (polygon) {
      this.$emit('input', {
        dezil: polygon[0],
        vermoegen: polygon[1],
        x: this.x(polygon[0]),
        y: this.y(polygon[1])
      })
    },
    mouseleave (polygon) {
      this.$emit('input', null)
    },
    mousemove (e) {
      /* eslint-disable */

      e.preventDefault()
      window.clearTimeout(this.fetchTimeout)
      if (this.dragging) {
        let mouse = {}
        mouse.x = e.layerX
        mouse.y = e.layerY

        let handle = {}
        handle.x1 = this.x(0)
        handle.x2 = this.x(100)
        handle.y1 = this.yCapped(this.wealth)-20
        handle.y2 = this.yCapped(this.wealth)+20

        if(mouse.x > handle.x1 && 
          mouse.x < handle.x2 && 
          mouse.y > handle.y1 && 
          mouse.y < handle.y2) {
          
          let newWealth = this.yToWealth(mouse.y)
          newWealth = Math.round(newWealth/1000)*1000
          this.$emit("update-wealth", newWealth)
        }

      }
      /* eslint-enable */
    },
    mousedown (e) {
      this.firstDrag = true
      this.dragging = true
    },
    mouseup (e) {
      window.clearTimeout(this.fetchTimeout)
      this.dragging = false
      // this.incomeActive = false
      // this.getData()
    },
    rotate (angle, originX, originY) {
      return 'rotate('+angle+','+originX+','+originY+')'
    }
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
    setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    this.fitProjection()
  },
  computed: {
    points: function () {
      return this.data.slice(1)
        .map((row, i) => {
          var point = [this.x((i+1)*10), this.y(row[1])]
          return point[0] + "," + point[1]
        })
        .join(" ")
      // return "20,20 40,25 60,40 80,120 120,140 200,180"
    },
    pointsRight: function () {
      let point = this.data.slice(-1)[0]
      return this.x(point[0]) + "," + this.y(point[1]) + " " + this.x(100) + "," + this.y(point[1]*1.8)
    },
    pointsLeft: function () {
      let point = this.data.slice(1)[0]
      let pointX = this.data.slice(2)[0]
      return this.x(0) + "," + this.y(point[1]-pointX[1]) + " " + this.x(point[0]) + "," + this.y(point[1])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .grid-label {
    font-size: 14px;
  }

  .vermoegen-label {
  font-weight: bold;
  fill: #D13D3D;
  text-shadow: 2px 2px 3px #fff;
}

.wealthButton {
  cursor: ns-resize;
}
</style>
